module.exports = __webpack_public_path__ + "static/media/books2.2cb817a1.png";